import { Antlr4Utils } from './antlr4-utils';
// Temporal workaround to gather TerminalNodeImpl type, ideally we should send a PR to ANTLR project to export the TerminalNodeImplType class from Tree.js file
const antlr4Tree = require('antlr4/tree/Tree');

export class Antlr4Types {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static get BasicNameContextType(): any {
        const dataflowParser = Antlr4Utils.getParserDefinition();
        return dataflowParser.DataflowParser.BasicNameContext;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static get TerminalNodeImplType(): any {
        return antlr4Tree.TerminalNodeImpl;
    }
}
